module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.8962/img/screenshot-twitter.png"